<template>
  <div
    id="product-slider"
    :class="{
      'product-slider': true,
      ['--for-' + slides[currentSlide - 1].id]: true,
    }"
  >
    <h2 class="product-slider__title" :class="{ '--seasonal': slides[currentSlide - 1].seasonal }">
      <template v-if="slides[currentSlide - 1].seasonal">
        СЕЗОННЫЙ ВКУС
        <div class="_row-2 --seasonal">В МИНИ-ФОРМАТЕ!</div>
      </template>
      <template v-else>
        Попробуй яркие вкусы<img
          src="../assets/img/product-slider/product-slider-sign.svg"
          alt=""
        />
        <div class="_row-2">Найди TUC <span>на свой вкус!</span></div>
      </template>
    </h2>

    <div class="product-slider__for-mini">В МИНИ-ФОРМАТЕ!</div>
    <div v-if="slides[currentSlide - 1].seasonal" class="product-slider__seasonal-badge">УСПЕЙ ПОПРОБОВАТЬ</div>

    <router-link :to="'/products/' + slides[currentSlide - 1].id">
      <img
        class="product-slider__about"
        src="../assets/img/product-slider-about-.svg"
        alt=""
      />
    </router-link>

    <img
      v-if="slides[currentSlide - 1].seasonal"
      class="product-slider__light"
      src="../assets/img/triangle2.svg"
      alt=""
    />
    <picture
      v-else-if="slides[currentSlide - 1].mini != true"
      class="product-slider__light"
    >
      <source
        media="(max-width: 768px)"
        srcset="../assets/img/product-slider/slider-light--mob.svg"
      />
      <img src="../assets/img/product-slider/slider-light.svg" />
    </picture>
    <img
      v-else
      class="product-slider__light"
      src="../assets/img/product-slider/slider-light--mini.svg"
      alt=""
    />

    <template v-for="(slide, slideIndex) in slides">
      <img
        v-if="slide.seasonal"
        v-show="currentSlide == slideIndex + 1"
        :key="'seasonal-' + slideIndex"
        class="product-slider__product"
        src="../assets/img/product-6.2969d7293.webp"
        alt=""
      />
      <picture
        v-else
        v-show="currentSlide == slideIndex + 1"
        :key="slideIndex"
        class="product-slider__product"
      >
        <source
          media="(max-width: 768px)"
          :srcset="
            require('../assets/img/product-slider/product-' +
              slide.id +
              '--mob.webp')
          "
        />
        <img
          :src="
            require('../assets/img/product-slider/product-' + slide.id + '.webp')
          "
          alt=""
        />
      </picture>
    </template>

    <img
      class="product-slider__arrow --left"
      src="../assets/img/slider-arrow-left.svg"
      alt=""
      @click="changeSlide('left', true)"
    />
    <img
      class="product-slider__arrow --right"
      src="../assets/img/slider-arrow-right.svg"
      alt=""
      @click="changeSlide('right', true)"
    />

    <div class="product-slider-dots-wrap">
      <div class="product-slider-dots">
        <span
          v-for="n in slidesQty"
          :key="n"
          :class="{
            'product-slider-dots__dot': true,
            '--active': currentSlide == n,
          }"
          @click="changeSlideNum(n)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import * as Hammer from "hammerjs"

export default {
  name: "ProductSlider",
  // components: { Hammer }
  props: {
    minus: Number,
  },
  data() {
    return {
      currentSlide: 1,
      slides: [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 },
        { id: 5 },
        { id: 6 },
        { id: 7, mini: true },
        { id: 8, mini: true },
      ],
      timer: 0,
    }
  },
  mounted() {
    if (this.minus != undefined) this.slides.splice(this.minus - 1, 1)

    var el = document.getElementById("product-slider")
    var _this = this
    let hammertime = new Hammer(el)
    hammertime.on("swipeleft", function () {
      _this.changeSlide("right")
    })
    hammertime.on("swiperight", function () {
      _this.changeSlide("left")
    })
    this.timer = setInterval(() => {
      this.changeSlide("right")
    }, 4000)
  },
  computed: {
    slidesQty() {
      return this.slides.length
    },
  },
  methods: {
    changeSlide(side, stopAuto = false) {
      if (stopAuto) clearInterval(this.timer)
      if (side == "left") {
        this.currentSlide =
          this.currentSlide == 1 ? this.slidesQty : this.currentSlide - 1
      } else {
        this.currentSlide =
          this.currentSlide == this.slidesQty ? 1 : this.currentSlide + 1
      }
      const slide = this.slides[this.currentSlide - 1]
      this.$emit("slide-change", { id: slide.id, num: this.currentSlide })
    },
    changeSlideNum(num) {
      clearInterval(this.timer)
      this.currentSlide = num
      const slide = this.slides[this.currentSlide - 1]
      this.$emit("slide-change", { id: slide.id, num: this.currentSlide })
    },
  },
}
</script>

<style lang="scss">
.product-slider {
  padding: 103px 0 88px;
  min-height: 800px;
  position: relative;
  transition: background-color 0.3s ease-in;
  overflow: hidden;
  &__title {
    @include title();
    font-size: 10.4rem;
    color: white;
    position: relative;
    z-index: 10;
    img {
      position: absolute;
      top: -30px;
      left: 50%;
      transform: translateX(370px);
    }
    ._row-2 {
      font-family: $font-text;
      font-size: 3.2rem;
      font-weight: 700;
      color: #00188a;
      text-transform: none;
      transform: translateX(128px);
      transition: opacity 0.1s ease-in;
    }
    ._for-mini {
      background-color: #e30a18;
    }
    &.--seasonal {
      transform: rotate(-5deg);
    }
    ._row-2.--seasonal {
      font-family: $font-text;
      font-size: 3.2rem;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      color: #00188a;
      text-transform: none;
      position: absolute;
      left: 50%;
      transform: translateX(143px) translateY(24px);
      width: fit-content;
    }
  }
  &__seasonal-badge {
    position: absolute;
    left: 50%;
    top: 39%;
    transform: translateX(151px) translateY(-50%);
    display: inline-flex;
    padding: 16px 24px;
    justify-content: center;
    align-items: center;
    border-radius: 15.359px;
    background: #e30a18;
    font-family: $font-peach;
    font-size: 3.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 1.28px;
    text-transform: uppercase;
    color: white;
    z-index: 10;
    white-space: nowrap;
  }
  &__light {
    position: absolute;
    top: 0;
    height: 100%;
    left: 50%;
    transform: translateX(-410px);
    z-index: 0;
  }
  &__product {
    position: absolute;
    width: 841px;
    bottom: 43px;
    left: 50%;
    transform: translate(-446px, 0px);
    z-index: 10;
    img {
      width: 100%;
    }
  }
  &__about {
    position: absolute;
    left: 50%;
    bottom: 166px;
    transform: translateX(228px);
    z-index: 20;
  }
  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    &.--left {
      left: 96px;
    }
    &.--right {
      right: 96px;
    }
  }
  &__for-mini {
    position: absolute;
    left: 52%;
    top: 27%;
    background-color: #e30a18;
    border-radius: 16px;
    font-family: $font-peach;
    font-size: 4.8rem;
    line-height: 0.7;
    padding: 24px 28px;
    color: white;
    white-space: nowrap;
    z-index: 1;
    opacity: 0;
  }
  &.--for-9 {
    background-color: #08a1bc; // seasonal
  }
  &.--for-1 {
    background-color: $color-product-1; // onion
  }
  &.--for-2 {
    background-color: $color-product-2; // cheese
  }
  &.--for-3 {
    background-color: $color-product-3; // pizza
  }
  &.--for-4 {
    background-color: $color-product-4; // salt
  }
  &.--for-5 {
    background-color: $color-product-5; // crab
  }
  &.--for-6 {
    background-color: $color-product-6; // sausage
  }
  &.--for-7 {
    background-color: $color-product-1; // mini 1
    ._row-2 {
      opacity: 0;
    }
    .product-slider__for-mini {
      opacity: 1;
    }
    .product-slider__product {
      width: 780px;
      bottom: 21px;
      left: 50%;
      transform: translate(-334px, 0px) rotate(-2deg);
    }
    .product-slider__light {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &.--for-8 {
    background-color: $color-product-2; // mini 2
    ._row-2 {
      opacity: 0;
    }
    .product-slider__for-mini {
      opacity: 1;
    }
    .product-slider__product {
      width: 780px;
      bottom: 21px;
      left: 50%;
      transform: translate(-334px, 0px) rotate(-2deg);
    }
    .product-slider__light {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.product-slider-dots-wrap {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 86px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
}
.product-slider-dots {
  height: 18px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 100px;
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &__dot {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    background-color: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    &.--active {
      background-color: #fff4c0;
    }
  }
}

@include respond-to("smartphone-plus") {
  .product-slider {
    padding: 109px 0 88px;
    min-height: max(110vh, 900px);
    border-radius: 48px 48px 0 0;
    margin-top: -48px;
    &__title {
      font-size: 4.8rem;
      max-width: 200px;
      display: block;
      margin: 0 auto;
      img {
        position: absolute;
        top: -25px;
        left: calc(50% + 8px);
        transform: translateX(70px);
        width: 40px;
      }
      ._row-2 {
        font-size: 1.6rem;
        transform: translateX(96px);
        max-width: 120px;
        text-align: left;
        margin-top: 4px;
        span {
          display: inline-block;
          padding-left: 12px;
        }
      }
    }
    &__product {
      // width: 480px;
      width: 100%;
      top: 0;
      // left: 0;
      // transform: translate(-240px, 0);
      transform: translate(-50%, 0);
      z-index: 9;
      img {
        width: 100%;
      }
    }
    &__about {
      transform: translateX(-95px);
      bottom: 205px;
    }
    &__arrow {
      top: auto;
      bottom: 132px;
      width: 48px;
      height: 48px;
      transform: translateY(0);
      z-index: 20;
      &.--left {
        left: 50%;
        transform: translateX(-134px);
      }
      &.--right {
        left: 50%;
        transform: translateX(86px);
      }
    }
    &__light {
      top: 0;
      height: auto;
      width: 420px;
      // width: 100%;
      transform: translateX(0);
      left: 0;

      img {
        width: 100%;
      }
      display: none;
    }
    &.--for-7,
    &.--for-8 {
      .product-slider__product {
        width: 490px;
        bottom: auto;
        top: 146px;
        transform: translate(-210px, 0px) rotate(-2deg);
      }
      .product-slider__light {
        display: block;
        left: 50%;
        transform: translateX(-50%);
        width: 420px;
        top: 0;
        height: auto;
      }
    }
    &.--for-9 {
      .product-slider__title {
        max-width: none;
        white-space: nowrap;
        font-size: 4.8rem;
        transform: rotate(-5deg);
        ._row-2.--seasonal {
          display: none;
        }
      }
      .product-slider__light {
        display: block;
        left: 50%;
        transform: translateX(-50%);
        width: 2325px;
        top: 0;
        height: auto;
      }
      .product-slider__product {
        width: 490px;
        bottom: auto;
        top: 130px;
        transform: translate(-234px, 54px);
      }
      .product-slider__seasonal-badge {
        font-size: 2rem;
        padding: 10px 16px;
        top: auto;
        bottom: 285px;
        left: 50%;
        transform: translateX(-50%);
      }
      .product-slider__for-mini {
        opacity: 1;
        top: 164px;
      }
    }
    &__for-mini {
      left: 50%;
      transform: translateX(-50%) rotate(-4deg);
      top: 210px;
      border-radius: 8px;
      font-size: 2.4rem;
      line-height: 0.7;
      padding: 14px 18px;
      color: white;
      z-index: 10;
      opacity: 0;
    }
  }
  .product-slider-dots-wrap {
    bottom: 147px;
  }

}

</style>
